export const categories = [
  {
    key: "game",
    name: "游戏",
    icon: "ri-gamepad-line",
    blurb: "MOBA、FPS、即时战略到沙盒生存，热门游戏的巅峰操作与战术复盘都在这里。",
    subs: ["MOBA", "FPS", "即时战略", "沙盒生存"],
  },
  {
    key: "entertainment",
    name: "娱乐",
    icon: "ri-emotion-happy-line",
    blurb: "脱口秀、户外纪实、搞笑连麦与音乐现场，放松解压的欢乐内容一站集齐。",
    subs: ["脱口秀", "户外", "搞笑", "音乐现场"],
  },
  {
    key: "talent",
    name: "才艺",
    icon: "ri-music-2-line",
    blurb: "唱歌、舞蹈、乐器、绘画，主播们扎实的表演功底与创作过程完整呈现。",
    subs: ["唱歌", "舞蹈", "乐器", "绘画"],
  },
];

export const streamers = [
  { id: "s01", name: "星野电竞", avatar: "星", popularity: "high", tagline: "职业退役，峡谷战术讲解" },
  { id: "s02", name: "蓝焰联盟", avatar: "蓝", popularity: "mid", tagline: "逆风翻盘教学主播" },
  { id: "s03", name: "枪神阿凯", avatar: "凯", popularity: "high", tagline: "FPS 枪法天花板" },
  { id: "s04", name: "夜鹰Nova", avatar: "N", popularity: "mid", tagline: "残局处理大师" },
  { id: "s05", name: "战术指挥官", avatar: "战", popularity: "low", tagline: "RTS 速攻流派研究者" },
  { id: "s06", name: "老张策略", avatar: "张", popularity: "low", tagline: "文明速通老玩家" },
  { id: "s07", name: "方块小宇", avatar: "宇", popularity: "high", tagline: "极限生存挑战达人" },
  { id: "s08", name: "冒险家Luna", avatar: "L", popularity: "mid", tagline: "沙盒全成就收集者" },
  { id: "s09", name: "段子手小北", avatar: "北", popularity: "high", tagline: "深夜吐槽金牌主播" },
  { id: "s10", name: "快乐制造机", avatar: "乐", popularity: "mid", tagline: "即兴喜剧演员出身" },
  { id: "s11", name: "户外阿泽", avatar: "泽", popularity: "mid", tagline: "城市探索与夜骑记录" },
  { id: "s12", name: "露营小分队", avatar: "营", popularity: "low", tagline: "山海露营慢直播" },
  { id: "s13", name: "逗趣大熊", avatar: "熊", popularity: "high", tagline: "粉丝互动名场面之王" },
  { id: "s14", name: "开心果酱", avatar: "酱", popularity: "mid", tagline: "连麦翻车专业户" },
  { id: "s15", name: "电台阿Moon", avatar: "M", popularity: "mid", tagline: "深夜电台点歌主持" },
  { id: "s16", name: "木吉他小林", avatar: "林", popularity: "low", tagline: "卧室音乐会发起人" },
  { id: "s17", name: "天籁小柔", avatar: "柔", popularity: "high", tagline: "高音挑战常驻嘉宾" },
  { id: "s18", name: "清唱阿泽", avatar: "清", popularity: "mid", tagline: "无伴奏清唱见长" },
  { id: "s19", name: "舞者小鹿", avatar: "鹿", popularity: "high", tagline: "国风爵士编舞师" },
  { id: "s20", name: "街舞阿King", avatar: "K", popularity: "mid", tagline: "街舞 Battle 老手" },
  { id: "s21", name: "琴键先生", avatar: "琴", popularity: "mid", tagline: "钢琴即兴改编" },
  { id: "s22", name: "弦月姑娘", avatar: "弦", popularity: "low", tagline: "古筝古风演奏" },
  { id: "s23", name: "画笔老李", avatar: "李", popularity: "low", tagline: "概念场景画师" },
  { id: "s24", name: "插画小满", avatar: "满", popularity: "mid", tagline: "板绘人物插画师" },
];